import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { Task } from '../../../../core';

@Component({
  selector: 'sgt-task-list',
  templateUrl: './task-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskListComponent {
  @Input() tasks: Task[] = [];

  @Output() clearAllClicked = new EventEmitter<void>();
  @Output() errorClicked = new EventEmitter<Task>();

  onClearAll(): void {
    this.clearAllClicked.emit();
  }

  onShowError(task: Task): void {
    this.errorClicked.emit(task);
  }

  trackByTask(_index: number, task: Task): Task {
    return task;
  }
}
